export enum InventoryOutputStateEnums {
    open = 1,
    close = 2
}